export const CHECKBOX = "checkbox";
export const SELECT = "select";
export const MULTISELECT = "multiselect";
export const RADIOBOX = "radio";
export const DATERANGE = "daterange";
export const DATESOLO = "date";
export const TEXTBOX = "text";
export const TEXTAREA = "textarea";
export const NUMERIC = "number";
export const EMAIL = "email";
export const VERTICAL = "vertical";
export const HORIZONTAL = "horizontal";
